import React, { Component } from "react";
import { CardHeader, Media, Input, Modal } from "reactstrap";
import {
  Col,
  Row,
  Nav,
  Card,
  Table,
  Form,
  Button,
  ButtonGroup,
  Breadcrumb,
  InputGroup,
  Dropdown,
} from "@themesberg/react-bootstrap";
import ReactTagInput from "@pathofdev/react-tag-input";
import "@pathofdev/react-tag-input/build/index.css";
import SpinDiv from "../components/SpinDiv";
import { toast } from "react-toastify";
import ReactDatetime from "react-datetime";
import moment from "moment";
import {editDeduction } from "../../services/salaryService";
import { InputNumber } from "antd";
export class EditDeduction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      page: 1,
      rows: 10,
      loading: false,
      edit:false,
      deduction:props.editDeduction,
      title:'',
      amount:''
    };
  }

  onChange = (e, state) => {
    this.setState({ [state]: e });
  };

  onSaveDeduction = async (e) => {
    e.preventDefault();
    await toast.dismiss();
    const { title, amount, reasons,start_date, end_date, validation } = this.state.deduction;
    await this.setState({
      validation: {
        ...validation,
        title: title !== '',
        amount: amount !== '',
        reasons: reasons !== '',
        start_date: start_date !== '',
        end_date:end_date !== ''

      },
    });
    if (Object.values(this.state.validation).every(Boolean)) {
      this.saveDeduction();
    } else {
      const errors = Object.keys(this.state.validation).filter((id) => {
        return !this.state.validation[id];
      });
      //await toast.configure({hideProgressBar: true, closeButton: false});
      toast.dismiss();
      toast.configure({ hideProgressBar: true, closeButton: false });
      
          toast(
            <div style={{ padding: "10px 20px" }}>
              <p style={{ margin: 0, fontWeight: "bold",color:"red" }}>Errors:</p>
              {errors.map((v) => (
                <p key={v} style={{ margin: 0, fontSize: 14,color:"red" }}>
                  * {this.validationRules(v)}
                </p>
              ))}
            </div>
          )
    }
  };

  validationRules = (field) => {
    if (field === "title") {
      return "Deduction title is required";
    } else if(field == 'amount'){
      return "Deduction Amount is required"
    } else if(field == 'reason'){
      return "Deduction Reason is required"
    }else if(field == 'end_date'){
      return "Deduction End date is required"
    } else if(field == 'start_date'){
      return "Start date  is required"
    }
  };


  onChange = (e, state) => {
    const {deduction} = this.state
    this.setState({deduction: {...deduction, [state]: e}})
  }


  saveDeduction = () => {
    this.setState({ loading: true });
    const {deduction} = this.state;
    let year= moment(deduction.start_date,"MMM D, YYYY").year()
    let month = moment(deduction.start_date,"MMM D, YYYY").month()+1;
    console.log();
    editDeduction({
      title: deduction.title,
      amount: deduction.amount,
      id:deduction.id,
      reason:deduction.reasons,
      start_date:deduction.start_date,
      end_date:deduction.end_date,
      active:deduction.active


    }).then(
      (res) => {
        console.log(res);
        this.setState({ loading: false });
        this.props.saved();
        this.props.toggle();
        this.showToast("Deduction has been updated");
      },
      (error) => {
        console.log(error);
        this.setState({ loading: false });
      }
    );
  };

  showToast = (msg) => {
    toast(<div style={{ padding: 20 }}>{msg}</div>);
  };

  toggleEdit = () => {
    this.setState({ edit: !this.state.edit });
  };

  render() {
    const { editDeduction, toggle } = this.props;

    const { saving, loading, title, amount, deduction, edit } = this.state;
    return (
      <>
        <Modal
          className="modal-dialog modal-dialog-top"
          isOpen={editDeduction != null}
          toggle={() => !loading && !saving && toggle}
        >
          {loading && <SpinDiv text={"Saving..."} />}
          <div className="modal-header" style={{ padding: "1rem" }}>
            <div className="btn-toolbar mb-2 mb-md-0">
              <ButtonGroup>
                <Button color={edit ? "secondary" : "success"}
                    onClick={this.toggleEdit}
                    size="sm" variant="outline-primary">
                    {edit ? "Discard Changes" : "Edit Deduction"}



                  </Button>
              </ButtonGroup>
            </div>

            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={toggle}
            ></button>
          </div>
          <Card border="light" className="shadow-sm mb-4">
            <Card.Body className="pb-0">
            <Row style={{ border: '1px #eee solid', padding: '5px 5px 5px', margin: '10px 2px 7px', borderRadius: 7 }}>
                    <Col md={12} style={{ paddingTop: 15 }}>
                      <Form.Group className="mb-2">
                        <Form.Label style={{ paddingRight: 10 }}>Deduction Title</Form.Label>
                        <Input
                          className="custom-control-input"
                          id="title"
                          placeholder='deduction Title'
                          value={deduction.title}
                          disabled={!edit}
                          onChange={async (e) => {
                            await this.onChange(e.target.value, "title");
                          }}
                          type="text"
                        />
                      </Form.Group>

                    </Col>
                    <Col md={12} style={{ paddingTop: 15 }}>
                      <Form.Group className="mb-2">
                        <Form.Label style={{ paddingRight: 10 }}>Deduction Amount</Form.Label>
                        <InputNumber

                          style={{ width:'100%', height: 40, paddingTop: 5, borderRadius: 5, fontSize: 18 }}
                          formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                          parser={value => value.replace(/\$\s?|(,*)/g, '')}
                          onKeyPress={(event) => {
                            if (!/[0-9]/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}

                          value={deduction.amount}
                          onChange={e => this.onChange(e, 'amount')}
                        />
          
                      </Form.Group>

                    </Col>

                    <Col md={12}>
                    <Form.Label style={{ paddingRight: 10 }}>Start Date</Form.Label>
                    <ReactDatetime
                          value={moment(deduction.start_date).format('MMM DD, YYYY') || ''}
                          dateFormat={"MMM DD, YYYY"}
                          onChange={(e) => this.onChange(e, "start_date")}
                          closeOnSelect
                          disabled={!edit}
                          //onChange={(e) => this.onChange(e, "start_date")}
                          inputProps={{
                            required: true,
                            className: "form-control date-width",
                          }}
                          timeFormat={false}
                        />
                    </Col>

                    <Col md={12}>
                    <Form.Label style={{ paddingRight: 10 }}>End Date</Form.Label>
                      <ReactDatetime
                         value={moment(deduction.end_date).format('MMM DD, YYYY') || ''}
                         dateFormat={"MMM DD, YYYY"}
                         onChange={(e) => this.onChange(e, "end_date")}
                         disabled={!edit}
                          closeOnSelect
                        
                          inputProps={{
                            required: true,
                            className: "form-control date-width",
                          }}
                          timeFormat={false}
                        />
                    </Col>
                    <Col md={12} style={{ paddingTop: 15 }}>
                      <Form.Group className="mb-2">
                        <Form.Label style={{ paddingRight: 10 }}>Reason for Deduction</Form.Label>
                        <Input
                          className="custom-control-input"
                          id="reason"
                          placeholder='Enter Deduction reason'
                          value={deduction.reasons}
                          disabled={!edit}
                          onChange={async (e) => {
                            await this.onChange(e.target.value, "reasons");
                          }}
                          type="textarea"
                        />
                      </Form.Group>

                    </Col>
                    <Col md={3} style={{ paddingTop: 15 }}>
                      <Form.Group className="mb-2">
                        <Form.Label style={{ paddingRight: 10 }}>Active</Form.Label>
                        <Input
                          className="custom-control-input"
                          id="active"
                          checked={deduction.active == 1 ? true : false}
                          onChange={async (e) => {
                            await this.onChange(e.target.checked, "active");
                          }}
                          type="checkbox"
                        />
                      </Form.Group>

                    </Col>
                    
                  </Row>
              <Row style={{ marginTop: "10px" }}>
                <Col md={12}>
                  <div>
                    <Button
                      variant="primary"
                      size="sm"
                      style={{ marginTop: "10px", float: "right" }}
                      disabled={saving}
                      onClick={this.onSaveDeduction}
                    >
                      Save
                    </Button>
                    <Button
                      size="sm"
                      variant="transparent"
                      data-dismiss="modal"
                      type="button"
                      disabled={saving}
                      style={{ marginTop: "10px", float: "right" }}
                      onClick={toggle}
                    >
                      {" "}
                      Close
                    </Button>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Modal>
      </>
    );
  }
}

export default EditDeduction;
